import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomerCountApi } from "../../apiservice/reports";
import { getSundryDebitorBalanceApi } from "../../apiservice/accounts";

export const fetchCustomerDue = createAsyncThunk(
  "customerDue/fetch",
  async ({ selectedFilterType, filters }, { rejectWithValue }) => {
    try {
      let totalCustomers = 0;
      const reqPayload = {
        locationId:
          selectedFilterType === "Location Wise" ? filters.locationId : null,
        customerId:
          selectedFilterType === "Customer Wise" ? filters.customerId : null,
        tag_groupnameid:
          selectedFilterType === "By Tag" ? filters.tagGroupId : null,
        tagFeildNameid:
          selectedFilterType === "By Tag" ? filters.tagFieldId : null,
        fromDate: filters.fromDate || undefined,
        toDate: filters.toDate || undefined,
      };

      // Get total customer count
      const countRes = await getCustomerCountApi(reqPayload);
      totalCustomers = countRes.data.count;

      let customerDueList = [];
      const pageSize = 50;
      const totalPages = Math.ceil(totalCustomers / pageSize);

      // If no customers found, return empty array
      if (totalPages === 0) {
        return [];
      }

      // Fetch all pages of customer data
      for (let page = 1; page <= totalPages; page++) {
        reqPayload.page_size = pageSize;
        reqPayload.page_number = page;

        const res = await getSundryDebitorBalanceApi(reqPayload);

        if (res.data && res.data.accounts) {
          // Filter out insurance accounts
          let accounts = res.data.accounts.filter(
            (item) => item.acc_type_name !== "Insurance"
          );

          // Apply additional filters based on selected type
          if (selectedFilterType === "All Debitor") {
            accounts = accounts.filter((item) => item.balance != 0);
          } else if (selectedFilterType === "Due List") {
            accounts = accounts.filter(
              (cus) => parseFloat(cus.balance || 0) > 0
            );
          }

          customerDueList = customerDueList.concat(accounts);
        }
      }

      // Add tag information if available and if filtering by tag
      if (
        selectedFilterType === "By Tag" &&
        filters.tagGroupId &&
        filters.tagFieldId
      ) {
        // You might need to enhance this part based on your tag data structure
        customerDueList = customerDueList.map((customer) => ({
          ...customer,
          tag_group: "Tag Group Placeholder", // Replace with actual tag group data
          tag_field: "Tag Field Placeholder", // Replace with actual tag field data
        }));
      }

      return customerDueList;
    } catch (err) {
      console.error("Error fetching customer due data:", err);

      // Handle specific error cases
      if (err.response?.status === 401) {
        sessionStorage.clear();
        window.location.reload();
        return rejectWithValue("Authentication failed");
      }

      return rejectWithValue(
        err.response?.data?.message ||
          err.message ||
          "Failed to fetch customer due data"
      );
    }
  }
);
